import React from 'react';

export const FONT_FAMILIES: Record<string, string> = {
  "Inter": "'Inter', sans-serif",
  "Rajdhani": "'Rajdhani', sans-serif",
  "Orbitron": "'Orbitron', sans-serif",
  "VT323": "'VT323', monospace",
  "Gothic": "'Bungee', sans-serif",
  "Retro": "'Space Mono', monospace",
  "Arcade": "'Press Start 2P', monospace",
  "Pixel": "'Silkscreen', monospace",
  "Horror": "'Oxanium', sans-serif",
  "Terminal": "'JetBrains Mono', monospace",
  "Ethereal": "'Cinzel', serif",
  "Ornate Imperial": "'Cinzel Decorative', serif",
  "Elven Script": "'Great Vibes', cursive",
  "Mythic Gothic": "'MedievalSharp', cursive",
  "Aura Round": "'Comfortaa', sans-serif",
  "Runic Scroll": "'Special Elite', monospace",
  "Audiowide": "'Audiowide', sans-serif",
  "Chakra Petch": "'Chakra Petch', sans-serif",
  "Uncial Antiqua": "'Uncial Antiqua', cursive",
  "Metamorphous": "'Metamorphous', cursive",
};

export function getNameStyle(style: string, c1: string, c2: string, dir: string = "90deg", animated: boolean = false): React.CSSProperties {
  switch (style) {
    case "Gradient":
      return animated
        ? {
            backgroundImage: `linear-gradient(${dir}, ${c1}, ${c2}, ${c1})`,
            backgroundSize: "220% auto",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }
        : {
            backgroundImage: `linear-gradient(${dir}, ${c1}, ${c2})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent"
          };
    case "Neon": 
      return { 
        color: c1, 
        textShadow: `0 0 8px ${c1}, 0 0 20px ${c1}80` 
      };
    case "POP": 
      return { 
        background: c1, 
        color: "#000", 
        padding: "2px 8px", 
        borderRadius: 6, 
        WebkitTextFillColor: "#000",
        display: "inline-block"
      };
    default: 
      return { color: "white" };
  }
}

export const LEGACY_BADGE_MIGRATION: Record<string, { icon: string; text: string }> = {
  'Fairy Queen':  { icon: '🧚', text: 'Queen' },
  'Star Weaver':  { icon: '✨', text: 'Weaver' },
  'Elven Sage':   { icon: '🧝', text: 'Sage' },
  'Void Druid':   { icon: '🌿', text: 'Druid' },
  'Void Walker':  { icon: '🔮', text: 'Walker' },
  'Cyber Runner': { icon: '👟', text: 'Runner' },
  'Grid Master':  { icon: '💾', text: 'Master' },
  'Data Miner':   { icon: '⛏️', text: 'Miner' },
};

export function migrateLegacyBadge(customization: any): any {
  if (!customization) return customization;
  const legacy: string = customization.badge;
  if (!legacy || legacy === 'None') return customization;
  if (customization.customBadgeText) return customization;
  const mapping = LEGACY_BADGE_MIGRATION[legacy];
  if (!mapping) return customization;
  return {
    ...customization,
    customBadgeIcon: mapping.icon,
    customBadgeText: mapping.text,
  };
}
